module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SpendXForDiscount"
  }, [_c('b-modal', {
    attrs: {
      "size": "lg",
      "visible": _vm.shown,
      "no-enforce-focus": ""
    },
    on: {
      "hide": _vm.hide,
      "shown": _vm.reset
    }
  }, [_c('div', {
    staticClass: "w-100",
    slot: "modal-title"
  }, [_c('strong', [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('ul', {
    staticClass: "nav nav-tabs card-header-tabs"
  }, [_c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerMustBuyError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-0",
    class: {
      active: _vm.tab == 0
    },
    on: {
      "click": function($event) {
        _vm.tab = 0
      }
    }
  }, [_vm._v("\n                The customer must make a purchase\n              ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    class: {
      'has-danger': _vm.customerWillGetError
    }
  }, [_c('a', {
    staticClass: "nav-link tab-1",
    class: {
      active: _vm.tab == 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_vm._v("\n                Customer will get\n              ")])])])]), _vm._v(" "), (_vm.tab === 0) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.requirements.purchaseTotalValue.$error
    },
    attrs: {
      "label": "with a total value of"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": " CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "purchaseTotalValue",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.requirements.purchaseTotalValue.$touch()
      }
    },
    model: {
      value: (_vm.promotion.requirements.purchaseTotalValue),
      callback: function($$v) {
        _vm.promotion.requirements.purchaseTotalValue = _vm._n($$v)
      },
      expression: "promotion.requirements.purchaseTotalValue"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.requirements.purchaseTotalValue.required),
      expression: "!$v.promotion.requirements.purchaseTotalValue.required"
    }],
    staticClass: "SpendXForDiscountPartialView__error"
  }, [_vm._v("\n              Required\n            ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "reward money"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "rewardMoneyEarned",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.rewards.rewardMoneyEarnedPerItem),
      callback: function($$v) {
        _vm.promotion.rewards.rewardMoneyEarnedPerItem = _vm._n($$v)
      },
      expression: "promotion.rewards.rewardMoneyEarnedPerItem"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "margin % target"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "targetMargin",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    model: {
      value: (_vm.promotion.targetMargin),
      callback: function($$v) {
        _vm.promotion.targetMargin = _vm._n($$v)
      },
      expression: "promotion.targetMargin"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.sumOff.$error || _vm.$v.promotion.rewards.percentageOff.$error
    },
    attrs: {
      "label": "for"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "CAD"
    }
  }, [_c('b-form-input', {
    staticClass: "sumOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": _vm.disableSumOff
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.sumOff.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.sumOff),
      callback: function($$v) {
        _vm.promotion.rewards.sumOff = _vm._n($$v)
      },
      expression: "promotion.rewards.sumOff"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2 text-center"
  }, [_vm._v("or")]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('b-input-group', {
    attrs: {
      "right": "%"
    }
  }, [_c('b-form-input', {
    staticClass: "percentageOff",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1,
      "disabled": _vm.disablePercentageOff
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.percentageOff.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.percentageOff),
      callback: function($$v) {
        _vm.promotion.rewards.percentageOff = _vm._n($$v)
      },
      expression: "promotion.rewards.percentageOff"
    }
  })], 1)], 1)]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.sumOff.required || !_vm.$v.promotion.rewards.percentageOff.required),
      expression: "!$v.promotion.rewards.sumOff.required || !$v.promotion.rewards.percentageOff.required"
    }],
    staticClass: "SpendXForDiscountPartialView__error"
  }, [_vm._v("\n\t\t  \tFill one or the other\n\t\t    ")])]), _vm._v(" "), _c('b-form-fieldset', {
    class: {
      'has-danger': _vm.$v.promotion.rewards.awardedAmount.$error
    },
    attrs: {
      "label": "off of"
    }
  }, [_c('b-input-group', {
    attrs: {
      "right": "items"
    }
  }, [_c('b-form-input', {
    staticClass: "awardedAmount",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "any",
      "rows": 1
    },
    on: {
      "input": function($event) {
        _vm.$v.promotion.rewards.awardedAmount.$touch()
      }
    },
    model: {
      value: (_vm.promotion.rewards.awardedAmount),
      callback: function($$v) {
        _vm.promotion.rewards.awardedAmount = _vm._n($$v)
      },
      expression: "promotion.rewards.awardedAmount"
    }
  })], 1), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.$v.promotion.rewards.awardedAmount.required),
      expression: "!$v.promotion.rewards.awardedAmount.required"
    }],
    staticClass: "SpendXForDiscountPartialView__error"
  }, [_vm._v("\n              Required\n            ")])], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5"
  }, [_vm._v("\n                once per day:\n                "), _c('b-form-checkbox', {
    staticClass: "oncePerDay",
    attrs: {
      "size": "lg",
      "value": "1",
      "unchecked-value": "0",
      "switch": ""
    },
    model: {
      value: (_vm.promotion.oncePerDay),
      callback: function($$v) {
        _vm.promotion.oncePerDay = $$v
      },
      expression: "promotion.oncePerDay"
    }
  })], 1)])]), _vm._v(" "), _c('product-list', {
    attrs: {
      "customerGroupId": _vm.promotion.customerGroupId,
      "discountedPriceFormula": _vm.discountedPriceFormula,
      "class-name": "SpendXForDiscount_awardedProducts",
      "validator": _vm.$v.promotion.rewards.awardedProducts
    },
    on: {
      "add": _vm.showProductSelect,
      "remove": _vm.removeAwardedProduct
    },
    model: {
      value: (_vm.promotion.rewards.awardedProducts),
      callback: function($$v) {
        _vm.promotion.rewards.awardedProducts = $$v
      },
      expression: "promotion.rewards.awardedProducts"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w-100",
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.savePromotion()
      }
    }
  }, [_vm._v("Done")])], 1)]), _vm._v(" "), (_vm.awardedProductSelectShown) ? _c('product-select', {
    attrs: {
      "shown": _vm.awardedProductSelectShown,
      "regionId": _vm.regionId,
      "maxCustomerGroupId": _vm.maxCustomerGroupId
    },
    on: {
      "hide": function($event) {
        _vm.awardedProductSelectShown = false
      },
      "change": _vm.addAwardedProduct
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-42e86c29"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/EditEvent/AddPromotion/SpendXForDiscount.vue
// module id = 1684
// module chunks = 1